<template>
  <v-container class="main-container">
    <v-row>
      <v-col cols="12">
        <v-card
          tile
          flat
          class="userBriefHistory pa-5"
          :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'"
        >
          <LowBalanceAccountrms></LowBalanceAccountrms>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LowBalanceAccountrms from "@/components/Rms/LowBalanceAccountrms.vue";
export default {
  components: {
    LowBalanceAccountrms
  },
};
</script>